export default "__VITE_ASSET__6796eb7a__"